// extracted by mini-css-extract-plugin
module.exports = {"container":"_34Zj5MBS","title":"_4y06947E","subtitle":"_2fGLPsR_","anchorLinks":"_39rZc_f0","link":"_1B8EvwWP","imageContainer":"_3as1uIe-"};